import { IS_EFBET } from 'services/constants';

export const Colors = {
  main: IS_EFBET ? ' #ffdd00' : ' #c03',
  white: ' #ffffff',
  black: ' #000000',
  black2: ' #212120',
  carbonBlack: '#2d2d2d',

  white2: ' #f2f2f2',
  white3: ' #dcdcdd',
  whisperGray: '#f1f1f1',

  gray: ' #ced4da',
  gray2: ' #f1f3f5',
  graphiteGray: '#5a5a5a',
  $stoneGray: '#8d8d8d',
  linkDefault: '#8AB4F8',
  linkVisited: '#C58AF9',
  linkHover: '#AECBFA',
  linkActive: '#669DF6',
  linkFocus: '#FDD663'
};
